import "core-js/modules/es.array.push.js";
import { InventoryService } from '@/services/inventory.service';
export default {
  data() {
    return {
      showDialog: false,
      alert: {
        show: false,
        message: ''
      },
      loading: false,
      label: '',
      inventory_id: null,
      inventoryOptions: [],
      amount: null,
      pharmacy_id: null,
      pharmacyOptions: []
    };
  },
  watch: {
    async showDialog(val) {
      if (!val) {
        this.loading = false;
        this.label = '';
        this.inventory_id = null;
        this.amount = null;
        this.pharmacy_id = null;
        this.inventoryOptions = [];
        this.pharmacyOptions = [];
        this.alert.show = false;
      } else {
        this.inventoryOptions = [];
        this.pharmacyOptions = [];
        const {
          data
        } = await InventoryService.getInventoryOptions();
        for (const item of data.inventoryItems) {
          this.inventoryOptions.push({
            value: item.id,
            text: item.name
          });
        }
        for (const item of data.pharmacies) {
          this.pharmacyOptions.push({
            value: item.id,
            text: item.name
          });
        }
      }
    }
  },
  methods: {
    async create() {
      this.loading = true;
      this.alert.show = false;
      if (this.label.trim().length == 0 || !this.inventory_id || !this.pharmacy_id || !this.amount) {
        this.alert.message = 'Please fill in all the fields.';
        this.alert.show = true;
        this.loading = false;
        return;
      } else {
        await InventoryService.addInventoryRestock({
          inventory_item_id: this.inventory_id,
          pharmacy_id: this.pharmacy_id,
          amount: this.amount,
          label: this.label
        });
        this.$emit('refresh');
        this.loading = false;
        this.showDialog = false;
      }
    }
  }
};